export const DateTime = {
    short: {
        year: "numeric",
        month: "short",
        day: "numeric"
    },
    long: {
        year: "numeric",
        month: "short",
        day: "numeric",
        weekday: "short",
        hour: "numeric",
        minute: "numeric",
        hour12: false
    }
}

export default {
    $vuetify: {
        dataIterator: {
            rowsPerPageText: 'Artículos por página:',
            rowsPerPageAll: 'Todos',
            pageText: '{0}-{1} de {2}',
            noResultsText: 'No se encontraron registros coincidentes',
            nextPage: 'Página siguiente',
            prevPage: 'Pagina anterior'
        },
        dataTable: {
            rowsPerPageText: 'Filas por página:'
        },
        noDataText: 'Datos no disponibles'
    },
    de: "Alemán",
    es: "Español",
    en: "Inglés",
    YES: "Sí",
    NO: "No",
    INSTALL: 'Instalado',
    INVENTORY: 'Inventario',
    NOT_ASSIGNED: 'No Asignado',
    RETIRED: 'Retirado',
    RMA: 'ADM',
    REMOVED: 'Eliminado',
    SWAP: 'Intercambiado',
    UNKNOWN: "Desconocido",
    netMet: "Network Metrics",
    ncs: "Network Command Suite",
    dashboard: "Tablero",
    channels: "Canales",
    uplinkRoutes: "Rutas de enlace ascendente",
    downlinkRoutes: "Rutas de enlace descendente",
    networkTune: "Network Tune",
    iam: "Infrastructure Asset Management",
    alarmDashboard: "Tablero de Alarmas",
    map: "Mapa",
    history: "Historia",
    alarms: "Alarmas",
    activeAlarms: "Alarmas Activas",
    graphs: "Graphicas",
    devices: "Dispositivos",
    details: "Detalles",
    endPoints: "Puntos Finales",
    radios: "Radios",
    towers: "Estaciones base",
    radioChannels: 'Canales de radio',
    radioUplinkRoutes: 'Rutas de enlace ascendente de radio',
    radioDownlinkRoutes: 'Rutas de enlace descendente de radio',
    radioDetails: "Detalles de la Radio",
    radioHistory: "Historia de la Radio",
    radioAlarms: "Alarmas de radio",
    radioMap: "Mapa de Radio",
    radioDashboard: "Tablero de Radio",
    radioReads: "Lecturas de radio",
    radioDeviceDetails: "Detalles Dispositivo",
    tuning: "Sintonización",
    configuration: "Configuración",
    commandChannels: "Canales de comando",
    bulkChannels: "Canales masivos",
    baseStation: "Estacion Base",
    baseStations: "Estaciones Base",
    status: "Estado",
    statistics: "Estadística",
    planning: "Planificación",
    config: "Configuración",
    tables: "Mesas",
    towerDetails: "Detalles de la Estación Base",
    towerGraphs: "Gráficos de Estaciones Base",
    towerDashboard: "Tablero de la Estación Base",
    towerDetailsDashboard: "Tablero Estación Base",
    towerActiveConfig: "Configuración activa de la estación base",
    towerMap: "Mapa de la Estación Base",
    towerHistory: "Historia de la Estación Base",
    towerAlarms: "Alarmas Estación Base",
    towerConfig: "Configuración de la Estación Base",
    systemPerformanceTabs: "Rendimiento de Sistema",
    systemMetrics: "Métrica del Sistema",
    systemDashboard: "Tablero del Sistema",
    ncsManagement: "Gestión NCS",
    systemOverview: "Resumen del Sistema",
    performanceDashboard: "Tablero del Rendimiento de Sistema",
    rnis: "Gestión de RNI",
    endPointConfig: "Configuración de Punto Final",
    towerTune: "Tuning Estacion Base",
    endPointTune: "Ajuste de Punto Final",
    customers: "Gestión de Clientes",
    manageReleases:'Administrar lanzamientos',
    customerDetails: "Detalles del Cliente",
    taskManagement: "Administración de tareas",
    outboundManagement: "Gestión del Tráfico Saliente",
    tuningConfiguration: "Configuración de Afinación",
    taskDetails: "Detalles de la tarea",
    frequencyMappings: "Asignaciones de Frecuencia",
    frequencyConfiguration: "Configuración de Frecuencia",
    endpointCountsByAlohaFrequency: "Recuento de puntos finales por frecuencia ALOHA",
    endpointCountsByPollFrequency: "Recuento de puntos finales por frecuencia de respuesta a la encuesta",
    endpointCountsByPriorityFrequency: "Recuento de puntos finales por frecuencia de prioridad",
    endpointCountsByDownlinkFrequency: "Recuento de puntos finales por frecuencia de enlace descendente",
    current: "Current",
    endpoints: "endpoints",
    detailsLinkTT: "Ir a detalles",
    destLinkTT: "Ir a los detalles del destino",
    detailsPlannedTT: "Valor planificado: {plannedValue}",
    launchPad: "Plataforma de lanzamiento",
    launchPadDesc: "Regresar a la plataforma de lanzamiento de Sensus",
    error: {
        noPermsTitle: "No tiene ningún permiso en la aplicación Network Command Suite",
        noPermsMsg: "Solicite permisos de Network Command Suite a su administrador del sistema",
        noCustomersTitle: "No ha sido asignado a ningún cliente con acceso a Network Command Suite",
        noCustomersMsg: "Solicite acceso de Network Command Suite a su administrador del sistema",
        genericErrorTitle: "Ha ocurrido un error inesperado",
        genericErrorMsg: "Por favor notifique a su administrador del sistema"
    },
    settings: {
        clearPreferences: "Borrar Preferencias",
        clearAllPrefs: "Borrar todas las preferencias",
        clearCurrentPagePrefs: "Borrar las preferencias de la página actual",
        setPreferences: "Establecer Preferencias",
        setPreferencesDesc: "Establecer Peferencias de Usuario"
    },
    statusChipStates: {
        COMPLETED: "Terminada",
        COMPLETE: "Completa",
        COMPLETED_WITH_WARNINGS: "Completado con advertencias",
        FAILED: "Fallida",
        IMPORTING: "Importadora",
        IN_PROGRESS: "En curso",
        QUEUED: "En cola",
        SUBMITTED: "Enviada",
        SUBMITTED_WITH_WARNINGS: "Enviado con advertencias",
        SUCCESS: "Éxito",
        VALIDATED: "Validada",
        VALIDATING: "Validando",
    },
    common: {
        date: "Date",
        time: "Time",
        name: "Nombre",
        history: "Historia",
        staleDataWarning: "No he tenido noticias desde el {targetValue}, los datos pueden estar obsoletos",
        uplinkTrafficDropWarning: "Estado de alarma de caída del tráfico del enlace ascendente desde {targetValue}, los datos pueden estar obsoletos",
        help: "Documentación de ayuda",
        tutorial: "Tutorial interactivo",
        actions: "Comportamiento",
        addAFilter: "Agregar un Filtro",
        all: "Todos",
        ok: "OK",
        apply: "Aplicar",
        save: "Salvar",
        cancel: "Cancelar",
        city: "Ciudad",
        close: "Cerca",
        true: "Cierto",
        false: "Falsa",
        confirm: 'Confirmar',
        change: "Cambiar",
        description: "Description",
        confirmDelete: "Confirmar Eliminación",
        confirmDisable: "Confirmar Discapacitado",
        clearAllSelectedRows: "Borrar todas las filas seleccionadas",
        showTune: 'Mostrar afinación',
        showConfig: "Mostrar configuración",
        showTable: "Mostrar Tabla",
        showGraph: "Mostrar Gráfico",
        resetDefaults: 'Restablecer predeterminados',
        defaultValue: 'Valor predeterminado',
        rule: 'Regla',
        delta: "delta",
        highest: "Más Alto",
        lowest: "Más Bajo",
        ncsRoles: "Permisos NCS",
        btsRoles:"Permisos de la estación base",
        userPermission: "Mis permisos",
        importUserPrefs: "Preferencias de importación",
        exportUserPrefs: "Preferencias de exportación",
        readUserPrefsError: "Se produjo un error al leer el archivo para importar",
        putUserPrefsError:"Se produjo un error al enviar preferencias al servidor",
        importSuccess: "Preferencias de usuario importadas correctamente",
        invalidPrefs:"Archivo de importación fallido y no válido",
        graphDurations: "Duraciones del Gráfico",
        graphDuration: "Duracion del Gráfico",
        graphIntervals: "Intervalos Gráficos",
        graphInterval: "Intervalo Gráficos",
        drilldown: "Profundizar",
        intervals: "Intervalos",
        frequency: "Frecuencía",
        HIGHEST: "Más Alto",
        LOWEST: "Más Bajo",
        count: "Contar",
        percentage: "Porcentaje",
        total: "Total",
        to: "a",
        and: "y",
        more: "más",
        search: "Buscar",
        second: "segundo",
        seconds: "segundos",
        minute: "minuto",
        minutes: "minutos",
        day: "día",
        days: "días",
        hour: "hora",
        hours: "horas",
        secondAbbrev: "s",
        dayAbbrev: "d",
        hourAbbrev: "hr",
        minuteAbbrev: "min",
        milesAbbrev: "mi",
        maximize: 'Maximizar',
        minimize: 'Minimizar',
        optional: 'Opcional',
        noLeadingSpaces: 'No se permiten espacios iniciales',
        valueIsRequired: 'Se requiere valor',
        integerIsRequired: 'Se requiere un número entero',
        fetchDataError: 'Error al recuperar datos',
        timezone: 'Zona Horaria',
        timezoneHint: 'Empieza a escribir para buscar zonas horarias',
        expandAll: 'Expandir Todo',
        collapseAll: 'Desplegar Todo',
        chartType: 'Tipo de Gráfico',
        customer: 'Cliente',
        threshold: 'Límite',
        throughput: 'Rendimiento',
        on: 'Habilitado',
        off: 'Deshabilitado ',
        exactMatch: 'Coincidencia exacta',
        unknown: 'Desconocida',
        notset: 'No Establecido',
        buddy: 'compañero',
        notApplicable: 'N/A',
        radioFrequencyLinkTT: 'Haga clic para mostrar la lista de radios con la frecuencia',
        towerFrequencyLinkTT: 'Haga clic para mostrar la lista de estaciones base con la frecuencia',
        averageMessages: "Promedio Mensajes",
        MANUALLY_DISABLED: 'Deshabilitada manualmente',
        COMMANDS_TIMING_OUT: 'Tiempo de espera de los comandos',
        errors: {
            invalidRequestTooManyResults: 'Hay demasiados registros para procesar, por favor filtre los datos para obtener un conjunto de datos más pequeño'
        },
        titleBar: {
            searchPlaceholder: "Buscar por ID o Nombre ...",
            searchPlaceholderExact: "Buscar por Identificación o Nombre exacto...",
            searchNoMatches: "No se encontraron coincidencias",
            searchSearching: "Buscando coincidencias ...",
            searchSearchingExact: "Buscando coincidencias exactas..."
        },
        refreshData: "Actualizar los datos mostrados",
        selectCustomer: "Seleccionar cliente",
        refreshRate:"Frecuencia de actualización",
        reconnect:"Reconectarse a la estación base",
        closeTab: "Cerrar pestaña",
        changeActiveCustomer: "Cambiar cliente activa",
        dateTime: "Fecha y hora",
        none: 'Ninguno',
        fileTypeErrMsg: 'Los tipos de archivo aceptables son solo {acceptFileType}',
        durationsList: "Lista de duracións",
        rfRegion: "Región RF",
        rfRegions: {
            STANDARD: "Estándar",
            FYLINGDALES: "Fylingdales",
            null: "No establecido"
        },
        cancelUpload: "Cancelar carga",
        deploy: "Desplegar",
        update: 'Actualizar',
        reboot: "Reiniciar",
        hide: 'Esconder',
        others: "Otras",
        edit: "Editar",
        fail: "Fallar",
        minimum: 'mínimo',
        maximum: 'máx',
        filters: 'Filtros',
        copyOf: 'Copia de ',
        partialCopyOf: 'Seleccionado {type} de ',
        messages: 'Mensajes',
        copied: 'Copiados al Portapapeles'
    },
    highcharts: {
        displayChartMenu: "Mostrar menú de carta",
        selectOne: "Todas las series de gráficos han sido deshabilitadas,<br> habilitó al menos una serie para ver los datos",
        selectOneWithBrTag: "Todas las series de gráficos<br> han sido deshabilitadas,<br> habilitó al menos una <br> serie para ver los datos",
        noData: "No hay datos para mostrar",
        loading: "Cargando",
        thousandsSep: ',',
        contextButtonTitle: "Menú Contextual del Gráfico",
        printChart: "Imprimir Gráfico",
        downloadPNG: "Descargar Imagen PNG",
        downloadJPEG: "Descargar Imagen JPEG",
        downloadSVG: "Descargar Imagen SVG",
        downloadPDF: "Descargar Documento PDF",
        months: [
            "Enero",
            "Febrero",
            "Marzo",
            "Abril",
            "Mayo",
            "Junio",
            "Julio",
            "Agosto",
            "Septiembre",
            "Octubre",
            "Noviembre",
            "Diciembre"
        ],
        resetZoom: "Restablecer Zoom",
        resetZoomTitle: "Restablecer nivel de zoom 1: 1",
        shortMonths: [
            "Ene",
            "Feb",
            "Mar",
            "Abr",
            "May",
            "Jun",
            "Jul",
            "Ago",
            "Sep",
            "Oct",
            "Nov",
            "Dic"
        ],
        weekdays: [
            "Domingo",
            "Lunes",
            "Martes",
            "Miércoles",
            "Jueves",
            "Viernes",
            "Sábado"
        ],
        downloadCSV: "Descargar CSV",
        downloadXLS: "Descargar XLS"
    },
    graph: {
        duration: "Duración",
        graphs: "Graficas",
        for: "para",
        average: "Promedio",
        averageSeconds: "Promedio (segundos)",
        minValue: "Valor Mínimo",
        maxValue: "Valor Máximo",
        minute: "Minuto",
        hour: "Hora",
        day: "Día",
        last24Hours: "Últimos 24 Horas",
        last1Days: "Ayer",
        last7Days: "Últimos 7 Días",
        last10Days: "Últimos 10 Días",
        last30Days: "Últimos 30 Días",
        networkPulse: {
            daily: "Diario",
            last7Days: "Semanal",
            last30Days: "Mensual",
            custom: "Selección",
            radioCountTitle: "Ver informes de radios por debajo del umbral"
        },
        displayChartMenu: "Mostrar menú de carta",
        includeToday: "Incluir Hoy",
        includeTodayDisabled: "Desactivada para duraciones personalizadas",
        startYAxisAtZero: "Comienoz Y Axis en Cero",
        fitYAxisGuidelines: "Ajustar el Gráfico a las Pautas",
        stackedArea: "Gráfico de Area Apilada",
        totalValues: "Contar",
        dayStartingAt: "Dia de Inicio",
        custom: "Personalizado",
        customDuration: "Duración Personalizada",
        startDate: "Fecha de inicio",
        endDate: "Fecha Final",
        interval: "Intervalo",
        intervals: "Intervalos",
        startDateRequired: "Se requiere fecha de inicio",
        endDateRequired: "Se requiere fecha de finalización",
        dataCalc: "Se están calculando los datos...",
        dashletControlsLoading: "Se están cargando datos de control de Dashlet...",
        xAxis: {
            MINUTE: "Minuto",
            HOUR: "Hora",
            DAY: "Día"
        },
        other: 'Otra',
        not_set: "No Establecido",
    },
    ordDeviceTrans: {
        ORD_Device: "Fecha Obsoleta del Dispositivo",
        ORD_Device_Datetime: "Fetcha Vieja"
    },
    thresholdTrans: {
        above: "Arriba",
        within: "Dentro",
        below: "Abajo",
        notAvailable: "N/A"
    },
    sets: {
        setMenu: "Administrar Conjuntos",
        setRequired: "Un conjunto si es necesario, cree un {link} luego recarga",
        createSetFromFilter: "Crear Conjunto de Filtro",
        createSetFromIds: "Crear Conjunto de Elementos Seleccionados",
        createSetFromFile: "Crear conjunto desde archivo",
        deleteSet: "Eliminar Conjunto",
        addSelectedToSet: "Añadir Elementos Seleccionados para Establecer",
        removeSelectedFromSet: "Eliminar Elementos Seleccionados del Conjunto",
        setCreated: 'Establecer \'{name}\' creado con éxito',
        setDeleted: 'Establecer \'{name}\' eliminado exitosamente',
        setUpdated: 'Establecer \'{name}\' actualizado exitosamente',
        setCreatedAsync: 'Crear solicitud para el conjunto \'{name}\' enviado. Ir a la historia para ver cuando se completa.',
        setDeletedAsync: 'Eliminar solicitud para el conjunto \'{name}\' enviado. Ir a la historia para ver cuando se completa.',
        setUpdatedAsync: 'Solicitud de actualización para el conjunto \'{name}\' enviado. Ir a la historia para ver cuando se completa.',
        setCreatedWithInvalidIds: 'Los siguientes identificadores en el archivo no eran válidos y fueron ignorados: {ids}',
        selectSet: 'Seleccionar Conjunto',
        setName: 'Nombre del Conjunto',
        noSets: 'No hay conjuntos disponibles',
    },
    customDuration: {
        durationStartDate90Error: "Cuando la fecha de inicio es hace más de 90 días, el intervalo debe ser día",
        durationStartDate30Error: "Cuando la fecha de inicio es hace más de 30 días, el intervalo debe ser día",
        durationStartDate7Error: "Cuando la fecha de inicio es hace más de 7 días, el intervalo debe ser hora o día",
        durationStartDateTodayError: "Cuando el intervalo es Día, la Fecha de finalización no se puede configurar para hoy",
        durationEndLessThanStartError: 'La fecha de finalización debe ser mayor o igual a la fecha de inicio',
        tooManyDaysForMinutesError: "Solo puede seleccionar el intervalo 'Minuto' durante 1 día",
        tooManyDaysForHoursError: "Solo puede seleccionar el intervalo 'Hora' para hasta {maxDays} días"
    },
    transmit: {
        priority: {
            1: "01 - SCRAM",
            2: "02 - DA",
            3: "03 - MOM-Comm",
            4: "04 - LAT Alta",
            5: "05 - Operador",
            6: "06 - LAT Normal",
            7: "07 - Usario 1",
            8: "08 - Ping de Hora",
            9: "09 - Usario 2",
            10: "10 - ACKs de Estacion Base",
            11: "11 - Usario 3",
            12: "12 - Usario 4",
            13: "13 - Usario 5",
            14: "14 - Usario 6",
            15: "15 - Usario 7"
        }
    },
    other: "Otro",
    metryDashboard: {
        addModule: 'Agregar Módulo'
    },
    download: {
        downloadFile: "Descargar archivo",
        downloadLimitQuestion: "Hay {totalRows} filas totales, ¿desea descargar las primeras {rowLimit} filas?",
        downloadCSV: "Descargar CSV",
        downloadIdsOnly: "Descargar solo Ids",
        downloadRadioSortMessage: "Nota: los registros se ordenarán por ID de representante"
    },
    polling: {
        submittedForCalculate: '{notificationStr} los datos deben calcularse, se le notificará cuando los datos estén disponibles',
        dataUpdatedRefresh: 'Los datos {notificationStr} se han actualizado, actualice el elemento correspondiente para que surta efecto',
        dataUpdatedLink: 'Los datos {notificationStr} se han actualizado, haga clic en el siguiente enlace para ir a la página correspondiente',
    },
    IMPERIAL: {
        "temperature": "Temperatura (F)"
    },
    METRIC: {
        "temperature": "Temperatura (C)"
    },
    filterboard: {
        groupContainerText: 'Seleccionar filtros guardados',
        min: 'Min',
        max: 'Max',
        disable: "Inhabilitar",
        enable: "Habilitar",
        close: "Cerca",
        isLoading: "Obtener datos de filtro...",
        noData: "No hay datos para este filtro",
        excludeItems: "No coincide",
        exactMatch: 'Coincidencia exacta',
        notset: 'No Establecido',
        regex: 'As RegEx'
    },
    metryDashboardV4: {
        refresh: 'Refrescar',
        maximize: 'Maximizar',
        minimize: 'Minimizar',
        displayActions: 'Acciones de Visualización',
        addModule: 'Agregar Dashlet',
        addModuleReadOnly: 'Para agregar dashlets, cree un nuevo tablero.',
        groupContainerText: "Seleccionar dashlets guardados",
        custom: "Personalizada"
    },
    customDashlet: {
        title: "Crear un Dashlet personalizado",
        pickDashletToCustomize: "Seleccione Dashlet para personalizar",
        loading: "Cargando...",
        search: "Buscar",
        idMinMax: "Elija al menos {min} y como máximo {max} artículos:",
        setHelpMsg: "Solo se muestran conjuntos con no más de {max} elementos",
        nameRequired: "Nombre de Dashlet personalizado requerido",
        dashletRequired: "Dashlet requerido",
        close: 'Cerrar',
        name: "Nombre",
        create: 'Crear'
    },
    groupContainer: {
        selectSavedFilter: "Seleccionar un grupo guardado",
        createTitle: "Guardar configuración como...",
        updateTitle: "Rebautizar",
        badGroupName: "Mal nombre de grupo",
        name: "Nombre",
        cancel: "Cancelar",
        save: "Salvar",
        ok: "OK",
        nameIsRequired: "Se requiere el nombre",
        duplicateName: "Nombre ya existe",
        confirmDeleteTitle: "Confirmar eliminación",
        confirmDelete: "¿Estás segura de que quieres eliminar?",
        search: "Buscar"
    },
    groupContainerAction: {
        actions: "Comportamiento",
        addModule: "Agregar módulo",
        createNamedGroup: "Crear nueva",
        updateNamedGroup: "Rebautizar",
        deleteNamedGroup: "Eliminar"
    }
}